/* unplugin-vue-components disabled */import script from "./DepositDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositDetails.vue?vue&type=script&setup=true&lang=js"

import "./DepositDetails.vue?vue&type=style&index=0&id=165b5c6a&lang=scss"

const __exports__ = script;

export default __exports__